import React from 'react'
import { Section, Image } from 'newComponents'
import spaceman from '../../../images/blog/thumbs-up-spaceman.png'

import './styles.scss'

const CategoryHeader = (props) => {
  const { category, description, isProductUpdate } = props
  // content checks
  const categoryNameHtml = category?.html
  const categoryDescriptionHtml = description?.html

  return (
    <Section className="category-header">
      <div className="category-header-container">
        <div className="category-header-text">
          {categoryNameHtml && (
            <div dangerouslySetInnerHTML={{ __html: categoryNameHtml }} className="category-header-title" />
          )}
          {categoryDescriptionHtml && (
            <div
              dangerouslySetInnerHTML={{ __html: categoryDescriptionHtml }}
              className="category-header-description"
            />
          )}
        </div>
      </div>
    </Section>
  )
}

export default CategoryHeader
